import { useEffect } from "react";
import { compose } from "redux";

import { accountBalanceConnector } from "../../../services/menu/dashboard/account.balance.connector";
import { currencyTag, moneyFormater } from "../../../utilities/formaters";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Currencies } from "../../../shared/dictionary/enums";

const FeeAccountBalance = ({ accountBalance, fetchAccountBalanceForDay }) => {
  const sek = currencyTag[Currencies.Sek];
  const eur = currencyTag[Currencies.Eur];

  useEffect(() => {
    if (!accountBalance[sek].fetching && !accountBalance[eur].fetching)
      fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchData = () => {
    fetchAccountBalanceForDay(null, sek);
    fetchAccountBalanceForDay(null, eur);
  };

  if (accountBalance[sek].fetched && accountBalance[eur].fetched) {
    let slFeeSek = accountBalance[sek].data.SavelendFees.Amount;
    let slFeeEur = accountBalance[eur].data.SavelendFees.Amount;
    let slTrustlySek = accountBalance[sek].data.TrustlyRecon.Amount;
    let slTrustlyEur = accountBalance[eur].data.TrustlyRecon.Amount;
    let slSwishSek = accountBalance[sek].data.SwishRecon.Amount;

    return (
      <span>
        <h3>Savelend account balances</h3>
        <br />
        <strong>SavelendFees</strong>:{" "}
        {moneyFormater(Math.floor(slFeeSek * 100) / 100)} {sek}
        <br />
        <strong>SavelendFees</strong>:{" "}
        {moneyFormater(Math.floor(slFeeEur * 100) / 100)} {eur}
        <br />
        <strong>TrustlyRecon</strong>:{" "}
        {moneyFormater(Math.floor(slTrustlySek * 100) / 100)} {sek}
        <br />
        <strong>TrustlyRecon</strong>:{" "}
        {moneyFormater(Math.floor(slTrustlyEur * 100) / 100)} {eur}
        <br />
        <strong>SwishRecon</strong>:{" "}
        {moneyFormater(Math.floor(slSwishSek * 100) / 100)} {sek}
      </span>
    );
  }
  return <CircularProgress />;
};

export default compose(accountBalanceConnector)(FeeAccountBalance);
